import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Box, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseButton } from '../base';

interface ErrorStateProps {
  title?: ReactNode;
  description?: ReactNode;
  actionLabel?: string;
  onAction?: () => void;
  actions?: ReactNode;
  icon?: ReactNode;
}

const ErrorState = ({
  title,
  description,
  actionLabel,
  onAction,
  actions,
  icon = <ReportProblemIcon color="error" />,
}: ErrorStateProps) => {
  const { t } = useTranslation();
  const resolvedTitle = title ?? t('visual.errorState.title');
  const resolvedDescription = description ?? t('visual.errorState.description');
  const resolvedActionLabel = actionLabel ?? t('visual.errorState.action');

  return (
    <Paper
      elevation={0}
      sx={theme => ({
        border: `1px solid ${theme.palette.error.light}`,
        borderRadius: 4,
        p: 3,
        backgroundColor:
          theme.palette.mode === 'dark'
            ? alpha(theme.palette.error.main, 0.12)
            : alpha(theme.palette.error.main, 0.08),
      })}
    >
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
        {icon}
        <Box>
          <Typography variant="subtitle1" color="error">
            {resolvedTitle}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {resolvedDescription}
          </Typography>
          {onAction && (
            <BaseButton sx={{ mt: 2 }} color="error" variant="outlined" onClick={onAction}>
              {resolvedActionLabel}
            </BaseButton>
          )}
          {actions && <Box sx={{ mt: 2 }}>{actions}</Box>}
        </Box>
      </Box>
    </Paper>
  );
};

export default ErrorState;
